import React from 'react'

import Menu from '../components/Menu'
import Routes from '../components/Routes'

import routes from './routes'

export const ContentMenu = ({ match }) => {
  return <Menu label="Content" routes={routes} url={match.url} />
}

const ContentRoutes = ({ match }) => (
  <Routes
    match={match}
    routes={routes}
    redirect={{ from: match.url, to: match.url + routes[0].path }}
  />
)

export default ContentRoutes
